import {
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { NoteService } from '../services/note_service';
import { StreamService } from '../services/stream_service';
import { Stream } from 'stream';
import { Note } from '../types/note';
import { UserService } from '../services/user_service';
import { Subscription } from 'rxjs';

export interface StreamExtType extends Stream {
  channels: Stream[];
  debug: Record<string, unknown>;
  total: number;
}

@Component({
  selector: 'streams-side-list',
  templateUrl: './streams-side-list.component.html',
  styleUrls: ['./streams-side-list.component.scss']
})
export class StreamsSideListComponent implements OnInit, OnDestroy {
  @Input() listType: string;
  @Input() display: string; // 'grid', 'windows'
  @Input() limit = 10;
  @Input() extendedList = false;
  @Input() notesImages = false;
  @Input() showPlaceholders = false;
  @Input() outputList?: Stream[];
  @Input() columns = 3;

  streamsList = [];
  dataListSub: Subscription;
  public loadingData = true;
  private isLoggedIn: boolean;

  constructor(
    private streamService: StreamService,
    private userService: UserService,
    private noteService: NoteService
  ) { }

  ngOnInit(): void {
    this.isLoggedIn = this.userService.isLoggedIn();
    this.getStreams(this.listType);
  }

  getStreams(category: string) {
    this.streamsList = [];
    this.loadingData = true;

    if (this.isLoggedIn) {
      this.noteService.getSubscriptionsLatestsPosts().then((results: any) => {
        const subStreams = results.channels;
        const subNotes = results.posts;
        const streamsArray = [];

        let postsStreamIds = [];

        if (subStreams && Object.keys(subStreams)) {
          for (const [key, value] of Object.entries(subStreams)) {
            streamsArray.push(value);
          }
        }

        if (subNotes.length) {
          for (const n of subNotes) {
            postsStreamIds.push(n.channelId);
          }

          postsStreamIds = Array.from(new Set(postsStreamIds));

          const subStreamDataList = [];

          for (const sid of postsStreamIds) {
            for (const stream of streamsArray) {
              if (sid === stream.id) {
                const notes = [];

                for (const n of subNotes) {
                  if (sid === n.channelId) {
                    notes.push(n);
                  }
                }
                stream.notes = notes;
                subStreamDataList.push(stream);
              }
            }
          }

          if (subStreamDataList.length < this.limit) {
            const orderedStreams = streamsArray.sort((a, b) => (a.updated > b.updated) ? -1 : 1);
            const cleanedStreams = [];

            for (const s of orderedStreams) {
              if (!postsStreamIds.filter(id => id === s.id).length) {
                cleanedStreams.push(s);
              }
            }

            for (let i = 0; (i < this.limit - subStreamDataList.length) && i < cleanedStreams.length; i++) {
              const addedStream = cleanedStreams[i];
              subStreamDataList.push(addedStream);
            }

            const notesLimit = 2;

            for (const stream of subStreamDataList) {

              if (!stream.notes) {
                stream.notes = [];
              }

              const query = {
                sort: 'createdDateDesc',
                size: 10
              };

              if (stream.notes.length < notesLimit - 1) {
                this.streamService.getStreamNotes(stream.id, query).then((notes: {posts: Note[]}) => {
                  const streamNotes = notes.posts;
                  const sortedNotes = [];

                  for (const note of streamNotes) {
                    if (!stream.notes.filter(n => n.id === note.id).length) {
                      sortedNotes.push(note);
                    }
                  }
                  stream.notes = stream.notes.concat(sortedNotes);
                });
              }
            }
          }
          this.streamsList = subStreamDataList;
          this.loadingData = false;
          this
        } else {
          this.prepareData(category);
        }
      });
    } else {
      this.prepareData(category);
    }
  }

  public urlifyName(title: string) {
    return this.noteService.urlifyName(title);
  }

  ngOnDestroy() {
    if (this.dataListSub) {
      this.dataListSub.unsubscribe();
    }
  }

  private prepareData(category: string): void {
    if (this.outputList) {
      this.setListResults(this.outputList);
    } else {
      if (category === 'popular') {
        this.dataListSub = this.noteService.getFeaturedChannels(0, this.limit).subscribe((result => {
          const streams = result.channels;
          this.setListResults(streams);
        }));
      } else {
        this.dataListSub = this.noteService.getNewestChannels(0, this.limit).subscribe((streams => {
          this.setListResults(streams);
        }));
      }
    }
  }

  private setListResults(streams: any) {
    const reloadedStreams = this.limit ? streams.slice(0, this.limit) : streams;

    for (const stream of reloadedStreams) {
      if (stream.postTags) {
        stream.tags = this.setTags(stream.postTags);
      }

      if (this.extendedList) {
        const query = {
          sort: 'createdDateDesc',
          size: 10
        };
        this.streamService.getStreamNotes(stream.id, query).then((notes: any) => {
          stream.notes = notes.posts || [];
        });
      }
    }
    this.streamsList = reloadedStreams;
    this.loadingData = false;
  }

  private setTags(tags: string[]): string[] {
    const tagsList = [];
    tags.map(tag => {
      const splitTag: any[] = tag.split('-');

      if (splitTag[0] === 'form' || splitTag[0] === 'category') {
        tag = (splitTag.length > 2) ? `${splitTag[1].replace('-', '')} ${splitTag[2]}` : splitTag[1].replace('-', '');
      }

      tagsList.push(tag);
    });

    return tagsList;
  }
}
